module.exports = __webpack_public_path__ + "img/logo.0ff9179c.png";